import { SVGComponentProps } from "./utils/Types"

const SuccessIcon = ({ width = 24, height = 24, className }: SVGComponentProps) => {
    return (
        <svg className={`text-current ${className}`} width={width} height={height} viewBox="0 0 24 24" fill="none">
            <g>
                <path id="Vector" d="M6 12L10.2426 16.2426L18.727 7.75732" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    )
}

export default SuccessIcon
